function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  color: "#fff",
  viewBox: "0 0 408 408"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M376.125 204c0-45.9-25.5-84.15-63.75-102v204c38.25-17.85 63.75-56.1 63.75-102zm-344.25-76.5v153h102l127.5 127.5V0l-127.5 127.5h-102z"
})));